/**
 * Normalizes a CMS image URL: maps the staging domain to production and
 * collapses the double slash present in some stored CMS entries.
 *
 * @param {string|null|undefined} url
 * @returns {string|null|undefined}
 */
export const transformImageUrl = (url) => {
  if (!url) {
    return url;
  }

  return url
    .replace("https://gravitas-sg.sites.sourceflow.co.uk", "https://www.gravitasgroup.com.sg")
    .replace("https://www.gravitasgroup.com.sg//", "https://www.gravitasgroup.com.sg/");
};
